import { CSSProperties } from 'react'

interface CardProps {
  children: React.ReactNode
  style?: CSSProperties
  image: { path: string }
}

export const ImageCard = (props: CardProps) => {
  const { children, style, image } = props

  return (
    <div
      className="flex flex-col bg-card shadow rounded overflow-hidden max-w-3xl bg-white"
      style={style}
    >
      <div className="h-28 overflow-hidden">
        <img src={image.path} width="100%" height={200} />
      </div>
      <div className="px-5 py-3">{children}</div>
    </div>
  )
}
